import { createSlice } from '@reduxjs/toolkit';

export const guidedDetails = createSlice({
    name: 'guidedDetails',

    initialState: {
        isGuidedModal: false,
        isGuidedProcess: false
    },

    reducers: {
        setGuidedModal: (state, action) => {
            state.isGuidedModal = action.payload;
        },

        setGuidedProcess: (state, action) => {
            state.isGuidedProcess = action.payload;
        }
    }
});

export const { setGuidedModal, setGuidedProcess } = guidedDetails.actions;

export default guidedDetails.reducer;
